import { render, staticRenderFns } from "./ParceirosForm.vue?vue&type=template&id=5e7a15c8&scoped=true&"
import script from "./ParceirosForm.vue?vue&type=script&lang=js&"
export * from "./ParceirosForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e7a15c8",
  null
  
)

export default component.exports